export const MARKETING_AUTOMATION_ROUTES = {
  marketingAutomation: '/marketing-automation',
  emailMarketing: '/email-marketing',
  featuredApplications: '/marketing/apps',
};
